import React from "react";
import ActivityIndicator from "../activity-indicator/ActivityIndicator";

import "./loading.css";

interface LoadingProps {
    showBrand: boolean;
    message: string;
}

const Loading = ({ showBrand, message }: LoadingProps) => (
    <div className="loading--container">
        <ActivityIndicator />
        <h1 className="loading--text">{message || "Carregando..."}</h1>
        {showBrand && (
            <div className="loading--image">
                {/* <img src={require('../../images/ame_brand.svg')} alt={'Logo AME'} /> */}
                <h1>Loading...</h1>
            </div>
        )}
    </div>
);

export default Loading;
